import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Back',
      changePassword: 'Change',
      copiedVaultId: 'Copied!',
      copyVaultID: 'Copy Vault ID',
      create: 'Create',
      next: 'Next',
      notSure: "I'm not sure",
      signUp: 'Sign up',
      submit: 'Submit',
      updatePassword: 'Update password',
    },
    Errors: {
      createReportFailed: 'Creating report failed.',
    },
    ReportStatus: {
      CLOSED: 'Closed',
      INVESTIGATING: 'Investigating',
      NEW: 'Submitted',
      READ: 'Read',
    },
    general: {
      navbar: {
        caseSettings: 'Case settings',
        changePassword: 'Change password',
        logOut: 'Log out',
        notifications: 'Notifications',
        notificationsDrawer: {
          appFileScanFailed: 'A file has failed security check',
          appReportMatch: 'Your GoTogether record has been matched',
          appReportReassigned: 'A new case manager has been assigned',
          case: 'Case',
          caseAssigned: 'Case assigned to you',
          caseImporterJobCompleted: {
            PartialSuccess: 'Your case import completed with errors',
            failure: 'Your case import failed',
            success: 'Your case import completed successfully',
          },
          caseLinked: 'Case linked',
          caseTeamInvite: 'Added to case',
          caseUnlinked: 'Case unlinked',
          dataSanitisation: 'Report details updated',
          emptyDescription: 'Check back later for new notifications',
          emptyTitle: "You're all caught up",
          importId: 'Import ID:',
          learnMore: 'Learn more',
          markAllAsRead: 'Mark all as read',
          newMessage: 'New message',
          newReport: 'New report received',
          permissionRemoved: 'Removed from case',
          postSSubmissionFile: 'Evidence file(s) added',
          report: 'Report ',
          reportAssigned: 'Report assigned to you',
          reportStatusChange: 'Report status changed',
          reporterAnonymised: 'Your details have been anonymised',
          reporterReportSubmitted: {
            subtitle: 'We recommend saving a copy of your report',
            title: 'Report submitted',
          },
          mitigationPlanReminder: 'Mitigation plan approval required',
          staleCase: 'Unactioned case',
        },
        privacyStatement: 'Privacy statement',
        reporter: {
          myReports: 'My reports',
        },
        settings: 'Settings',
        technicalSupport: 'Technical support',
        title: 'Account',
      },
      time: {
        day: 'Day',
        days: 'Days',
        hour: 'Hour',
        hours: 'Hours',
        minute: 'Minute',
        minutes: 'Minutes',
        second: 'Second',
        seconds: 'Seconds',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anonymous',
        autoTranslate: 'Auto-translate is turned off by default.',
        backToMessages: 'Back to messages',
        caseSettings: 'Case settings.',
        changeInProfile:
          'If you wish to change this setting, you can do so in your profile ',
        deletedByMessage: 'Deleted by {{author}}',
        deletedMessageLabel: 'This message was deleted',
        description:
          'When auto-translation is turned on, all report messages will be\n          automatically translated using AI based on the default language\n          selected on your browser.',
        descriptionSecondHalf:
          'The original version of all messages is always preserved and can be found in the chat.',
        messagePlaceholder: 'Start typing...',
        messageSettings: 'Message settings.',
        originalMessages: 'Original',
        showMoreBanner: 'Learn more about auto translations',
        titlev2: 'Read all messages in your preferred language.',
        translatedMessageLabel: 'Translated Message',
        translatedMessages: 'Translated',
        understood: 'Understood',
      },
      Country: {
        description: 'In which country are you based?',
        header: 'In which country are you based?',
        noOptions: 'No countries found',
        other: 'Other',
        placeholder: 'Search for a country...',
      },
      CreatePublicReport: {
        createReport: 'Create a report',
        helpPage: 'Go to our help page',
        loginToOpr: 'Login to Track Reports',
        or: 'or',
        passwordPlaceholder: 'Enter Password',
        phoneNumberLoginFailed: 'Login failed, phone number/pin incorrect',
        phoneNumberPlaceholder: 'Enter your Phone Number',
        phoneNumberTooltip:
          'Enter the phone number you used to contact VaultTalk',
        pinPlaceholder: 'Enter Pin',
        reportIntroductionParagraph1:
          'When reporting an incident, you’ll be asked a few questions to support you in documenting your experience.',
        reportIntroductionParagraph2:
          'Before you submit, you have the option to remain anonymous to protect your privacy.',
        reportIntroductionParagraph3:
          'After you submit, you can log in at any time to see the progress of your report & talk to a case manager.',
        reportIssue: 'Report an issue',
        usernameLoginFailed: 'Login failed, username/password incorrect',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired:
              'Relationship to company is required',
            reportedCategoryRequired: 'Reported category is required',
          },
        },
        vaultId: 'Vault ID',
        vaultIdPlaceholder: 'Enter your Email or Vault ID',
        vaultIdTooltip:
          "For anonymous reports the Vault ID is alphanumeric. If the report wasn't anonymous, the Vault ID is your email address",
        vaultTalk: 'VaultTalk',
        yourPassword: 'Your Password',
        yourPhoneNumber: 'Your Phone Number',
        yourPin: 'Your 6 Digit Pin',
        yourVaultId: 'Your Vault ID',
      },
      CustomHeader: {
        companyLogo: '{{company}} Logo',
        openReporting: 'Open Reporting',
        userSettings: 'User Settings',
      },
      Date: {
        approximateDescription:
          'Do you remember the approximate date the event took place?',
        approximatePlaceholder:
          'Example: 6 months ago / last year / last November',
        cancel: 'cancel',
        clear: 'clear',
        description: 'Do you remember the date the event took place?',
        header: 'What day did it take place?',
        ok: 'ok',
        placeholder: 'Example: 21 June 2020',
      },
      Description: {
        whatHappened: 'What happened?',
        whatHappenedPlaceholder: 'Use your own words...',
        whatHappenedText: 'In your own words, describe what happened',
      },
      Details: {
        disclaimer:
          'These details will be disclosed with your report. If you wish to remain anonymous, ensure they do not contain identifying information.',
        emailPlaceholder: 'Email (optional)',
        fullNamePlaceholder: 'Full Name (optional)',
        header: 'Your details',
        nonAnonSubtitle:
          'Please provide either your name or an email address. If you want to receive notifications about this report, add an appropriate email address below.',
        nonOptionalEmailPlaceholder: 'Email',
        nonOptionalFullNamePlaceholder: 'Full Name',
        subtitle:
          'If you want to receive notifications about this report, add an appropriate email address below.',
      },
      Emotion: {
        description: 'How did it make you feel? What was the impact?',
        header: 'What was the impact?',
        placeholder: 'Start typing...',
      },
      Evidence: {
        addedHeading: 'Added',
        deletedMessage: 'was deleted',
        deletedStatus: 'Deleted',
        failedToOpenFileMessage: 'Failed to open file. Please try again',
        fileStatuses: {
          infectedUpload: 'Flagged by security check',
          passedUpload: 'Passed security check',
          pendingUpload: 'Security check in progress',
          readyForDownload: 'Ready for download',
        },
        mobileErrorMessage: 'Flagged files: message your case manager',
        nameHeading: 'Name',
        statusHeading: 'Status',
        tableTitle: 'Evidence',
        webErrorMessage:
          'Flagged files: If your file(s) has been flagged, please message the case manager',
      },
      FileUpload: {
        addFiles: 'Add files',
        addMoreFiles: 'Add more files',
        confirm: 'Confirm',
        description:
          'Adding files as evidence can help support the efficiency of resolution by your case manager. Please consider the file content (including file metadata) if you wish to remain anonymous, and respect other individuals rights and applicable laws.',
        dragDrop: 'Drop files here or',
        errorMessage:
          'File(s) failed due to a network error. Click below to message your case manager for assistance',
        fileLimit: 'Each file size limit: 100MB',
        fileUploadLimitText: 'You can only upload 10 files',
        header: 'Add evidence',
        helpArticle: 'help article',
        highlighted: 'browse files',
        information: 'Supported file types',
        moreInformation: 'For more info, please see this <a>help article</a>',
        postSubmissionErrorMessage:
          "We couldn't upload your files due to a system error. Please select 'confirm' again.",
        tooltipAudio: 'Audio:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Documents:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Images:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Text:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Video:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'File is too large',
          invalidFileType: 'Unsupported file type: {{extension}}',
          systemError: 'System error',
          tooManyFiles: 'Maximum number of files is {{maxFiles}}',
        },
        uploadFiles: 'Upload files',
      },
      Loading: {
        loading:
          'Please wait whilst we submit your report to a case manager...',
        postSubmissionLoading: 'Please wait whilst we submit your files(s)...',
      },
      Location: {
        description: 'Where did it happen?',
        header: 'Where did it happen?',
        placeholder: 'Example: In the office',
      },
      MessageListBox: {
        messageCaseManager: 'Message case manager',
        report: 'Report {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Translation disabled',
        enableTranslationLabelEnabled: 'Translation enabled',
        enableTranslationsDescription:
          'Enable auto-translations and read all report messages in your preferred language. The translated language is based on the language selected on your device.',
        enableTranslationsHeader:
          'Enable auto-translations for report messages',
        enableTranslationsSubDescriptionv2:
          'You can switch between the translated and original language in each chat.',
        updateTranslationFailed: 'Update translation failed',
        updateTranslationSuccess: 'Translation setting updated successfully',
      },
      Password: {
        changePasswordHeader: 'Change',
        createNewPassword: 'Please create a new password',
        createPasswordHeader: 'Your Password',
        currentPasswordPlaceholder: 'Enter current password',
        description:
          'A valid password must be at least 9 characters long and include one uppercase letter and one number',
        enterCurrentPassword: 'Please enter your current password',
        forgottenPasswordInstructions:
          'Enter your alphanumeric Vault ID (not your email address) and email address to reset your password.',
        newDescription:
          'Create a strong password to keep your account secure. Start typing to see guidelines below.',
        passwordPlaceholder: 'Create a password',
        passwordResetRequestedDescription:
          'If your Vault ID exists in our system, you will receive an email with instructions to reset your password.',
        passwordResetRequestedHeader: 'Password reset link requested',
        reenterPlaceholder: 'Enter the password again',
        subtitle:
          'Create a password to submit this report and access it in the future',
        yourVaultId: 'Your Vault ID',
        yourVaultIdPlaceholder: 'Enter your Vault ID (eg. {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Are you reporting a specific person or multiple people? Could you name or describe them?',
        header: 'People involved',
        placeholder:
          'Start typing and use a comma to add multiple names or descriptions',
      },
      PoweredByVault: 'Powered by {{company}}',
      PrivacyStatement: 'Product Privacy Statement',
      PublicMessageList: {
        myMessages: 'My messages',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Evidence added to existing report',
        backToReportId: 'Back to report ID: {{reportId}}',
        description:
          'Adding files as evidence can help support the efficiency of resolution by your case manager. Please consider the file content (including file metadata) if you wish to remain anonymous, and respect other individuals rights and applicable laws. For more info, please see this <a>help article</a>',
        header: 'Add additional evidence to the report',
        vaultTalkOpenCaseHeader: 'Add evidence to your report',
      },
      PublicReport: {
        anonymous: 'Anonymous',
        backToReports: 'Back to reports',
        skipped: 'Skipped',
      },
      PublicReportCard: {
        addEvidence: 'Add additional evidence',
        messageCaseManager: 'Message case manager',
        reportId: 'Report ID:',
        submitted: 'Submitted',
        vaultTalkClosedCaseCTA: 'View Evidence',
        vaultTalkOpenCaseCTA: 'Add Evidence',
        viewAdditionalEvidence: 'View additional evidence',
        viewReport: 'View Report',
      },
      PublicReportsList: {
        reportingSystem: 'Reporting System',
      },
      Question: {
        placeholder: 'Start typing...',
        question: 'Provide details',
        questionText: 'Please share your concern, update, or inquiry with us',
      },
      Relationship: {
        header: 'Your relationship to the organisation',
        tellUsAbout:
          'Please tell us about your relationship with the organisation.',
      },
      ResponsiveNavMenu: {
        messages: 'My messages',
        reports: 'My reports',
      },
      Site: {
        description: 'At which site are you based?',
        header: 'At which site are you based?',
        noOptions: 'No sites found',
        other: 'Other',
        placeholder: 'Search for a site...',
      },
      SpamPuzzle: {
        dialog: 'In order to continue, please solve this puzzle',
      },
      SubmissionTypes: {
        reportIssue: 'Select a category',
        whatType: 'Select the category that best describes your report',
      },
      SubmitSuccess: {
        category: '<bold>Category:</bold> {{category}}',
        country: '<bold>Country:</bold> {{country}}',
        dateSubmitted: '<bold>Date submitted:</bold> {{date}}',
        recordYourVaultID: 'Remember this information for login',
        successInformation: 'More information',
        successMessage:
          'Your report has been submitted and is ready for review. Any files attached that requires attention will be flagged upon login. Log in below to view report updates and message your case manager.',
        successSanitationMessage:
          'Save a copy for your records, and keep your Vault-ID safe — you’ll need it to access updates and message your case manager.',
        successSanitationTagline:
          'Your report was submitted and securely stored.',
        successThankYou: 'Thank you for your report!',
        viewReport: 'View report',
      },
      Time: {
        approximateDescription:
          'Do you remember the approximate time the event took place?',
        approximatePlaceholder: 'Example: in the morning, in the afternoon',
        description: 'Do you remember the time the event took place?',
        header: 'What time did it happen?',
        invalidTime: 'Time format must be HH:MM',
      },
      UserSettingsDialog: {
        changePassword: 'Change password',
        closeDialog: 'Close Dialog',
        logout: 'Log out',
        messageSettings: 'Message Settings',
        userSettings: 'User Settings',
      },
      Witnesses: {
        description:
          'Did you tell anyone else, or did anyone see what happened?',
        header: 'Any witnesses?',
        placeholder: 'Start typing...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Send message',
        title: 'Message Case Manager',
        translationHeader: 'Learn more about auto translations',
      },
      ReportCard: {
        addEvidence: 'Add evidence',
        submissionModeVia: 'via {{submissionMode}}',
        viewEvidence: 'View evidence',
      },
      ReportList: {
        yourReports: 'Your Reports',
      },
      ReportingActivate: {
        buttonText: 'Continue',
        description:
          "If your organisation has registered you for an account, we'll send you an email with instructions to complete set up.",
        emailInput: 'Email',
        header: 'Enter your work email',
        successAccount:
          "If your organisation has registered you for an account, we'll send you an email with instructions to complete set up.",
        successEmail:
          "If you don't immediately see it, please wait a few minutes and refresh your email inbox.",
        successHeading: 'Thank you',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Add evidence to your report',
        descriptionText:
          'Adding files as evidence can help support the efficiency of resolution by your case manager. Please consider the file content (including file metadata) if you wish to remain anonymous, and respect other individuals rights and applicable laws.  For more info, please see this <a>help article</a>',
        emptyMessage: 'No additional evidence uploaded',
      },
      ReportingChangePassword: {
        back: 'Back',
        description:
          'Create a strong password to keep your account secure. Start typing to see guidelines below.',
        errorToast: "Can't create password, invalid token.",
        header: 'Change Password',
        incorrectCurrentPassword:
          'The current password is wrong. Please check it and try again.',
        invalidToken: 'Invalid token',
        passwordUpdated: 'Password updated',
        passwordUpdatedDescription:
          'Your password has been successfully updated. Thanks for taking this step to keep your data secure!',
        passwordUsedBefore: 'Password reuse not allowed',
        passwordUsedBeforeDescription:
          "For your safety, you can't reuse any of your last six passwords. Please choose a new, unique password to keep your account secure and try again.",
        toastDescription:
          'Your password has been successfully updated. Thanks for taking this step to keep your data secure!',
        toastMessage: 'Password updated',
        updatePasswordCTA: 'Update password',
      },
      ReportingConnect: {
        cancelButton: 'Cancel',
        connectButton: 'Connect',
        disclaimer:
          'Connecting your Slack account with your Vault account ensures a secure and private connection.<br /><br />By connecting, you can report misconduct or ask a question directly within Slack. You’ll always have the option to report anonymously after connecting. Your privacy and security are our top priorities.',
        heading:
          ' Vault Platform is requesting permission to access your {{organisationName}} Slack account ',
        listHeading: 'What will Vault be able to do?',
        permissionIdentity: {
          extraInfo:
            "Vault will have the ability to view your Slack user's identity",
          heading: "View information about a user's identity",
        },
        permissionNotifications: {
          extraInfo:
            'Vault will be able to send you notifications to you Slack account, regarding any updates to a submitted report or question',
          heading: 'Send you notifications',
        },
        permissionOverview: {
          extraInfo:
            'Vault will surface an overview of all submissions in the homepage',
          heading: 'Overview of submissions',
        },
        permissionSubmitReport: {
          extraInfo:
            'This will grant Vault permission to submit a report or ask a question, directly to your organisation, from Slack',
          heading: 'Submit a report or question on your behalf',
        },
        successfulConnectionDescription:
          'Your Vault account and Slack account are now connected. You can now close this tab and return to Slack.',
        successfulConnectionHeading: 'Successfully connected',
        unsuccessfulConnectionDescription:
          'Something went wrong. Please close this tab and return to Slack to try again.',
        unsuccessfulConnectionHeading: 'Connection failed',
      },
      ReportingForgotPassword: {
        description:
          'Enter the email address associated with your account, and we’ll send you a link to reset your password.',
        heading: 'Forgotten password',
        invalidTokenError: "Can't create password, invalid token.",
        passwordReuseError: 'Password reuse not allowed',
        passwordReuseErrorDescription:
          "For your safety, you can't reuse any of your last six passwords. Please choose a new, unique password to keep your account secure and try again.",
        sendLink: 'Send reset link',
        sendLinkFailure: 'Something went wrong',
        sendLinkFailureDescription:
          'Head back to the <a>Reporter Hub</a> and try again. If the issue continues, reach out to us at <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Password reset link sent',
        sendLinkSuccessDescription:
          "We've sent a password reset link to {{email}}",
        updatePasswordSuccess: 'Password updated',
        updatePasswordSuccessDescription:
          'Your password has been successfully updated. Thanks for taking this step to keep your data secure!',
      },
      ReportingLogin: {
        accountFrozen: 'Account is frozen',
        accountLocked:
          'Login has been attempted too many times incorrectly. The account is locked for up to 1 hour. Password reset is not possible during this time',
        accountLockedPermanently:
          'Your account has been locked. Use reset password to regain access or contact your system administrator for further help.',
        createAccountCTA: 'Register for an account',
        currentPassword: 'Current Password',
        emailLabel: 'Your Email',
        forgotPassword: 'Forgot your password?',
        loginButton: 'Login',
        newPasswordPlaceholder: 'New password',
        passwordFailMessage:
          'Head back to the Vault App in Slack and try again. If the issue continues, reach out to us at techsupport@vaultplatform.com',
        passwordFailTitle: 'Something went wrong',
        passwordLabel: 'Your Password',
        passwordPlaceholder: 'Enter your password',
        passwordResetRequired: 'Password reset required',
        passwordSuccessfullySetMessage:
          'Head back to the Vault App in Slack and authenticate with your new password to continue where you left off.',
        passwordSuccessfullySetTitle: 'Password successfully set',
        reenterPlaceholder: 'Re-enter password',
        title: 'Reporter Hub',
        tooltip:
          'If you\'ve never set a password for the Vault app yet, follow here to get started. If you’ve forgotten your password, use the "Forgot Password" link below.',
        usernameLoginFailed: 'Login failed, username or password incorrect',
      },
      ReportingReset: {
        failureDescription:
          'Head back to the Vault App in Slack and try again. If the issue continues, reach out to us at <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Something went wrong',
        successDescription:
          'Head back to the Vault App in Slack and authenticate with your new password to continue where you left off',
        successHeading: 'Password successfully set',
      },
      noReports: {
        description:
          "All submitted reports will show here. Learn more about the ways you're able submit a report in",
        descriptionHelpArticle: 'this help article',
        errorDescription:
          "We're struggling to load your reports. Please try refreshing the page.",
        errorDescriptionSecondary:
          'If that does not work, please reach out to us at',
        errorTitle: "⚠️ Oops, something's gone wrong",
        title: 'You have no reports yet',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Enable auto-translations and read all report messages in your preferred language. The translated language is based on the language selected on your device.',
          autoTranslationDescription2:
            'You can switch between the translated and original language in each chat.',
          autoTranslationTitle: 'Enable auto-translations for report messages',
          header: 'Message Settings',
          subHeader: 'Configure how messages are displayed',
        },
        notificationSettings: {
          emailDescription:
            'Receive email notifications for important updates to your reports',
          emailTitle: 'Email Notifications',
          header: 'Notification Settings',
          subHeader: 'Configure how you receive notifications',
        },
        title: 'Settings',
        updatedSettingsFailure: 'Failed to update your settings',
        updatedSettingsSuccess: 'Successfully updated your settings',
      },
    },
    validators: {
      passwordLength: 'Password must be at least 9 characters long',
      passwordLowercase: 'Password must contain at least 1 lowercase letter',
      passwordMissMatch: 'The password and confirmation fields have to match.',
      passwordNumeric: 'Password must contain at least 1 number',
      passwordUppercase: 'Password must contain at least 1 uppercase letter',
    },
    validatorsNew: {
      passwordLength: 'Between 10 and 30 characters',
      passwordLowercase: 'At least one lowercase letter',
      passwordMissMatch: 'Passwords don’t match',
      passwordNumeric: 'At least one number',
      passwordSpecialCharacter: 'At least one special character',
      passwordUppercase: 'At least one uppercase letter',
    },
  },
};

export default translations;
